/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `'BickhamScript', serif;`,
  subHeading: `'Unna', serif;`,
  subHeading_lv2: `'Unna', serif;`,
  body: `'Cormorant Upright', serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    // lineHeight: '1',
    textAlign: 'center',
    p: '8px',
    color: 'secondaryColorText',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    // lineHeight: '1',
    // color: 'secondaryColorText',
    textAlign: 'center',
  },
  subHeading_lv2: {
    fontFamily: 'subHeading_lv2',
    fontSize: 'subHeading_lv2',
    fontWeight: 'subHeading_lv2',
    fontStyle: 'var(--fontItalic-subHeading_lv2)',
    // lineHeight: '1',
    color: 'secondaryColorText',
    textAlign: 'center',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
    textAlign: 'center',
  },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.body,
  variant: 'solid',
  padding: '18px 20px',
  borderRadius: '18px',
  background: `linear-gradient(to right, var(--chakra-colors-bgPrimary), var(--chakra-colors-bgAlternative))`,
  color: 'mainColorText',
  size: 'sm',
  boxShadow: 'md',
  fontStyle: 'normal',
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
